import React from 'react'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'

import CompletedActivityArrow from './CompletedActivityArrow'
import Dot from './Dot'
import './styles.scss'

const baseClass = 'time-line-dots'

const TimeLineDots = ({
  isStoryActivatedForOrganization,
  userActivities,
  currentDay,
  proTrackName,
  isMobile,
  limit,
  page,
  isShowFeatureDot,
  positionElement,
}) => (
  <div className={baseClass}>
    {isShowFeatureDot && positionElement !== -1 && <CompletedActivityArrow positionElement={positionElement} />}
    {userActivities.map((activity, index) => (
      <Dot
        key={`history_${index}`}
        activity={activity}
        currentDay={currentDay}
        proTrackName={proTrackName}
        limit={limit}
        isMobile={isMobile}
        index={page * limit + index + 1}
        isStoryActivatedForOrganization={isStoryActivatedForOrganization}
      />
    ))}
    {userActivities.size < limit && <div className={`${baseClass}__rest`} />}
  </div>
)

TimeLineDots.propTypes = {
  isShowFeatureDot: PropTypes.bool.isRequired,
  userActivities: ImmutablePropTypes.list.isRequired,
  positionElement: PropTypes.number.isRequired,
}

export default TimeLineDots
